/**
 * DEPRECATED: This module is deprecated. Use classes that extend and interact with the observers/Observable module.
 */
/** The name of the module */
export const name = 'Observable';
// eslint-disable-next-line @typescript-eslint/ban-types
export function observable(targetClass) {
    const { prototype } = targetClass;
    prototype.subscribe = function subscribe(callback, eventName = '') {
        // Using this method instead of CatalogItem.addToInitQueue() because not all observables are instances of CatalogItem
        if (typeof this.observers === 'undefined') {
            this.observers = new Map();
        }
        this.observers.set(callback, eventName);
    };
    prototype.notify = function notify(data, eventName = '') {
        if (!this.observers) {
            return;
        }
        this.observers.forEach((subscribedEventName, callback) => {
            // Make sure that event name is empty, the subcribed (filtered) event name is empty, or that they match
            if (eventName === '' || subscribedEventName === '' || subscribedEventName === eventName) {
                callback(data, eventName);
            }
        });
    };
    return targetClass;
}
